import { AxiosResponse } from "axios";
import config from "../../../../config/config";
import ApiClient from "../../ApiClient";
import {
    OfferFileResponse,
    OfferRequest,
    OfferResponse, OfferTempPdf, SendMailDto
} from "./types";
import {EmailLogResponse} from "../emailLog/types";

const api = new ApiClient("/Offer", config.api.baseUrl);

/**
 * Get all offers basic information.
 */
export const getAllOffers = (): Promise<OfferResponse[]> => {
    return api
        .get(`/List`)
        .then((response: AxiosResponse<OfferResponse[]>) => {
            return Promise.resolve(response.data);
        })
        .catch((error) => {
            return Promise.reject(error);
        });
};

/**
 * Get offer basic information.
 * @param offerId
 */
export const getOfferDetails = (offerId: number): Promise<OfferResponse> => {
    return api
        .get(`/${offerId}`)
        .then((response: AxiosResponse<OfferResponse>) => {
            return Promise.resolve(response.data);
        })
        .catch((error) => {
            return Promise.reject(error);
        });
};
/**
 * Get offer default data.
 */
export const getInitialData = (): Promise<OfferResponse> => {
    return api
        .get(`/Defaults`)
        .then((response: AxiosResponse<OfferResponse>) => {
            return Promise.resolve(response.data);
        })
        .catch((error) => {
            return Promise.reject(error);
        });
};

/**
 * Generate printable offer
 * @param offerId
 */
export const generateOffer = (offerId: number): Promise<OfferTempPdf> => {
    return api
        .get(`/${offerId}/Generate`, {
            responseType: "blob",
        })
        .then((response: AxiosResponse<Blob>) => {
            return Promise.resolve({
                data: response.data,
                id: parseInt(response.headers["x-offer-file-id"])
            });
        })
        .catch((error) => {
            return Promise.reject(error);
        });
};

/**
 * Send email regarding offer
 * @param offerId
 */
export const sendEmail = (offerId: number, data: SendMailDto): Promise<void> => {
    return api
        .post(`/${offerId}/SendEmail`, data)
        .then((response: AxiosResponse<Blob>) => {
            return Promise.resolve();
        })
        .catch((error) => {
            return Promise.reject(error);
        });
};

/**
 * Get send email default data.
 */
export const getSendEmailInitialData = (offerId: number): Promise<SendMailDto> => {
    return api
        .get(`/${offerId}/SendEmailDefaults`)
        .then((response: AxiosResponse<SendMailDto>) => {
            return Promise.resolve(response.data);
        })
        .catch((error) => {
            return Promise.reject(error);
        });
};

/**
 * Update offer information.
 * @param offerID
 * @param data
 */
export const updateOffer = (offerId: number, data: OfferRequest): Promise<OfferResponse> => {
    return api
        .post(`/${offerId}`, data)
        .then((response: AxiosResponse<OfferResponse>) => {
            return Promise.resolve(response.data);
        })
        .catch((error) => {
            return Promise.reject(error);
        });
};

/**
 * Add new offer.
 * @param token
 * @param data
 */
export const addOffer = (data: OfferRequest): Promise<OfferResponse> => {
    return api
        .post(`/New`, data)
        .then((response: AxiosResponse<OfferResponse>) => {
            return Promise.resolve(response.data);
        })
        .catch((error) => {
            return Promise.reject(error);
        });
};


/**
 * Delete offer.
 * @param token
 * @param offerId
 */
export const deleteOffer = (offerId: number): Promise<void> => {
    return api
        .delete(`/${offerId}`)
        .then((response: AxiosResponse<void>) => {
            return Promise.resolve(response.data);
        })
        .catch((error) => {
            return Promise.reject(error);
        });
};

/**
 * Get all offers attachments.
 * @param token
 * @param code
 */
export const getAllOfferAttachments = (offerId: number): Promise<OfferFileResponse[]> => {
    return api
        .get(`/${offerId}/Files`)
        .then((response: AxiosResponse<OfferFileResponse[]>) => {
            return Promise.resolve(response.data);
        })
        .catch((error) => {
            return Promise.reject(error);
        });
};

/**
 * Delete offer attachment.
 * @param token
 * @param code
 */
export const deleteOfferAttachment = (offerId: number, attachmentId: number): Promise<void> => {
    return api
        .delete(`/${offerId}/Attachment/${attachmentId}`)
        .then((response: AxiosResponse<void>) => {
            return Promise.resolve(response.data);
        })
        .catch((error) => {
            return Promise.reject(error);
        });
};

/**
 * Get emails sent regarding the offer (newest first).
 * @param offerId
 */
export const getOfferEmails = (offerId: number): Promise<EmailLogResponse[]> => {
    return api
        .get(`/${offerId}/Emails`)
        .then((response: AxiosResponse<EmailLogResponse[]>) => {
            return Promise.resolve(response.data);
        })
        .catch((error) => {
            return Promise.reject(error);
        });
};
